import React from 'react';

import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const {ExpandableView, Text} = MojitoPresentation.Components;

export default class EventDisclaimer extends MojitoCore.Presentation.UIViewImplementation {
    shouldDisplay() {
        const {displayForSports: sportsFilter} = this.config;
        const {isInPlay, sportId} = this.props;

        return (
            sportsFilter.includes('all') ||
            sportsFilter.includes(sportId) ||
            (isInPlay && (sportsFilter.includes('all_inplay') || sportsFilter.includes(`${sportId}_inplay`))) ||
            (!isInPlay && (sportsFilter.includes('all_notinplay') || sportsFilter.includes(`${sportId}_notinplay`)))
        );
    }

    render() {
        const {isVirtual} = this.props;
        const {expandableView, contentText, infoLink} = this.config;

        return this.shouldDisplay() ? (
            <ExpandableView headerText={this.resolveString('$DBX.EVENT_DISCLAIMER.HEADER')} config={expandableView}>
                <div style={contentText.style}>
                    {isVirtual ? (
                        <Text config={{isHtml: true}}>
                            {this.resolveString('$DBX.EVENT_DISCLAIMER.CONTENT_VIRTUAL')}
                        </Text>
                    ) : (
                        <React.Fragment>
                            {this.resolveString('$DBX.EVENT_DISCLAIMER.CONTENT')}
                            {infoLink.link && (
                                <React.Fragment>
                                    {' '}
                                    <a href={infoLink.link} style={infoLink.style}>
                                        {this.resolveString('$DBX.EVENT_DISCLAIMER.LINK_TITLE')}
                                    </a>{' '}
                                    {this.resolveString('$DBX.EVENT_DISCLAIMER.LINK_DESCRIPTION')}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </ExpandableView>
        ) : null;
    }
}
